// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".field[data-v-74ab5128],.field .duration-wrapper[data-v-74ab5128]{display:flex;flex-direction:column;gap:8px}.field .duration-wrapper .selected-duration-wrapper[data-v-74ab5128]{display:flex;align-items:center;gap:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
